module.exports = __webpack_public_path__ + "img/footer-robot.16ee8020.png";